import React from 'react'
import classNames from 'classnames'
import { isAfter, startOfDay } from 'date-fns'
import { AsP, EyebrowMD, EyebrowSM, Footer, HeadingSM } from '@/atoms/Text'
import { useLocale } from '@/utils/LocaleUtil'

interface DateCardProps {
  date: Date
  disabled: boolean
  onClick: () => void
  selected: boolean
  useDivider?: boolean
}

export const SpecialDateCard: React.FC<DateCardProps> = ({ date, disabled, onClick, selected, useDivider = false }) => {
  const { locale } = useLocale()
  const hasEnded = isAfter(startOfDay(new Date()), startOfDay(date))

  return (
    <div className="relative">
      <div
        className={classNames(
          'w-[72px] h-24 relative rounded-xl hover:scale-105 hover:bg-white bg-core-gray-200 text-core-gray-900 border-[1.5px] border-core-gray-200 hover:!z-30',
          {
            'cursor-not-allowed': disabled,
            'cursor-pointer': !disabled,
            '!border-transparent !bg-core-gray-950 shadow-[0_8px_16px_-1px_rgba(0,0,0,0.08)]': selected,
            '!border-core-gray-200 !bg-white': !selected,
          },
        )}
        onClick={() => {
          if (disabled || hasEnded) return
          onClick()
        }}
      >
        <div className="flex h-full flex-col justify-center pt-0.5 text-center">
          <EyebrowMD
            color="core-gray-700"
            className={classNames('uppercase', {
              '!text-core-gray-400': selected,
            })}
          >
            {date.toLocaleString(locale, { month: 'short' })}
          </EyebrowMD>
          <HeadingSM
            as={AsP}
            weight="bold"
            className={classNames('leading-[36px] tracking-[-1px]', {
              '!text-white': selected,
            })}
          >
            {date.getDate()}
          </HeadingSM>
          <EyebrowSM
            color="core-gray-700"
            className={classNames('uppercase', {
              '!text-core-gray-400': selected,
            })}
          >
            {date.toLocaleString(locale, { weekday: 'short' })}
          </EyebrowSM>
          <Footer
            italic={true}
            color={selected ? 'white' : 'copper'}
            weight={'medium'}
            className={'text-[8px] leading-3'}
          >
            Early Release
          </Footer>
        </div>
      </div>
      {useDivider && (
        <div className="absolute -right-3 top-1/2 z-10 h-[60px] w-[1px] -translate-y-1/2 rounded bg-core-gray-300" />
      )}
    </div>
  )
}
